import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { HooksService, ListRow } from 'basic-components';
import TimeService from 'dashboard-services/services/TimeService';
import { StatusIcon } from 'primary-components';

import RunTime from 'basic/RunTime';

import './Row.scss';

const toSentenceText = key => {
  const result = String(key).replace(/([A-Z])([a-z])/g, " $1$2")
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const Content = ({ startTime, setHeight, warnStatuses, endTime, component, message, payload, status, isRunning }) => {
  const root = useRef(),
        definedTime = useSelector(state => state.myAccountState.settingsState.definedTime),
        date = useMemo(() => TimeService.getUserFormattedDateTime(startTime, definedTime, TimeService.ISO_DATE_TIME_FORMAT_WITH_MILLIS).split(" "), [startTime, definedTime]),
        windowWidth = HooksService.useWindowSize()

  useEffect(() => {
    root.current && setHeight(root.current.getBoundingClientRect().height + 24);
  }, [windowWidth, setHeight]);

  return (
    <div 
        className="statuses__details__content__body__list__row__content"
        ref={root}
    >
      <div className="statuses__details__content__body__list__row__content__item statuses__details__content__body__list__row__content__item--time">
        {date[1]}
      </div>
      <div className="statuses__details__content__body__list__row__content__item statuses__details__content__body__list__row__content__item--status">
        <div className="statuses__details__content__body__list__row__content__item--status__icon">
          <StatusIcon
              status={status}
              warnStatuses={warnStatuses}
              withAnimation={isRunning}
          />
        </div>
        <div className="statuses__details__content__body__list__row__content__item--status__text">
          {status?.toString().toLowerCase().capitaliseFirstLetter()}
        </div>
      </div>
      <div className="statuses__details__content__body__list__row__content__item statuses__details__content__body__list__row__content__item--run-time">
        <RunTime
            endTime={endTime}
            isRunning={isRunning}
            startTime={startTime}
        />
      </div>
      <div className="statuses__details__content__body__list__row__content__item statuses__details__content__body__list__row__content__item--execution">
        {component || ""}
      </div>
      <div className="statuses__details__content__body__list__row__content__item statuses__details__content__body__list__row__content__item--message">
        {message || ""}
        <br/>
        <div className="statuses__details__content__body__list__row__content__item__payload">
          {Object.entries(payload || {}).filter(([key]) => key !== "nodeId" && key !== "pipelineId" && key !== "version").map(([key, val]) => (
            <div 
                className="statuses__details__content__body__list__row__content__item__payload__position"
                key={`${key}${val}`}
            >
              <div className="statuses__details__content__body__list__row__content__item__payload__position__label">
                {toSentenceText(key)}:
              </div>
              <div className="statuses__details__content__body__list__row__content__item__payload__position__value">
                {val}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )

}

const EMPTY_OBJ = {};

const EMPTY_ARRAY = [];

const Row = ({ scrollRef = EMPTY_OBJ, component = "", message = "", endTime = undefined, payload = EMPTY_OBJ, startTime = undefined, warnStatuses = EMPTY_ARRAY, status = undefined }) => {
  const [height, setHeight] = useState(36)

  return (
    <ListRow 
        className="statuses__details__content__body__list__row"
        height={height}
        scrollContRef={scrollRef}
    > 
      <Content
          component={component}
          endTime={endTime}
          message={message}
          payload={payload}
          setHeight={setHeight}
          startTime={startTime}
          status={status}
          warnStatuses={warnStatuses}
      />
    </ListRow>
  )
}

Row.propTypes = {
  component: PropTypes.string,
  endTime: PropTypes.string,
  message: PropTypes.string,
  payload: PropTypes.object,
  scrollRef: PropTypes.any,
  startTime: PropTypes.string,
  status: PropTypes.string,
  warnStatuses: PropTypes.array,
}

Content.propTypes = Row.propTypes

export default Row;